/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any): any => ({
  async index(data?: any) {
    return camelize(await $axios.get(`/match-rating`, snakelize({ params: data })))
  },

  async bulkStoreOrUpdateRatings(data?: any) {
    return camelize(
      await $axios.post(`/match-rating/bulk-store-or-update`, snakelize(data))
    )
  },

  // async show(data?: any) {
  //   return camelize(await $axios.get(`/match-rating/${data.id}`, snakelize({ params: data })))
  // },

  // async delete(data?: any) {
  //   await camelize($axios.delete(`/match-rating/${data.id}`, snakelize({ data: data })))
  // },
})
